<template>
  <template v-if="editionMode">
    <SelectComponent
      v-model="localModelValue"
      :multiple="multiple"
      :searchable="searchable"
      :name="name"
      :values="orderedUser"
      :label="label"
      display-key="full_name"
      :required="required"
      :edition-mode="editionMode"
      :errors="errors"
    />
  </template>
  <BaseShowLabel v-else :label="label" :model-value="selectedLabel" />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'
import BaseShowLabel from '@c/addf-package/components/BaseLabel/BaseShowLabel.vue'

export default {
  name: 'SelectUser',
  components: { BaseShowLabel, SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    onlyFuneralHomes: {
      type: Array,
      required: false,
      default: () => []
    },
    onlyRoles: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  computed: {
    ...mapGetters('metadata', { users: 'getAllUsersMetadata' }),
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    orderedUser() {
      return [...this.users]
        .filter(
          (user) => {
            if (user.id === this.modelValue) return true;

            const hasForbiddenRole = user.roles.some((role) =>
              ['super-admin', 'api_connection'].includes(role)
            );
            if (hasForbiddenRole) return false;

            const hasOnlyScreen = user.roles.length === 1 && user.roles[0] === 'screen';
            if (hasOnlyScreen) return false;

            return true;
          })
        .when(
          Array.isArray(this.onlyFuneralHomes) &&
            this.onlyFuneralHomes.length > 0,
          (users) =>
            users.filter(
              (user) =>
                user.funeral_homes_id.some((funeral_home) =>
                  this.onlyFuneralHomes.includes(funeral_home)
                ) || user.id === this.modelValue
            )
        )
        .when(
          Array.isArray(this.onlyRoles) && this.onlyRoles.length > 0,
          (users) =>
            users.filter(
              (user) =>
                user.roles.some((role) => this.onlyRoles.includes(role)) ||
                user.id === this.modelValue
            )
        )
        .sort((a, b) => a.full_name.localeCompare(b.full_name))
    },
    selectedLabel() {
      return this.users.find((user) => user.id === this.modelValue)?.full_name
    }
  }
}
</script>
